import { SVGProps } from 'react';
const SvgReddit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_405)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#FF4500"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.43 28.0159C27.3155 28.0159 26.3809 27.1009 26.3809 25.9722C26.3809 24.8419 27.3155 23.8969 28.43 23.8969C29.5428 23.8969 30.4452 24.8419 30.4452 25.9722C30.4452 27.1009 29.5443 28.0159 28.43 28.0159ZM28.7136 31.7922C27.7293 32.7889 26.1864 33.2739 23.9985 33.2739C21.8092 33.2739 20.2677 32.7889 19.2849 31.7922C19.0714 31.5756 19.0714 31.2253 19.2849 31.0074C19.497 30.7908 19.8436 30.7908 20.0571 31.0074C20.825 31.786 22.1134 32.1657 23.9985 32.1657C25.8822 32.1657 27.1722 31.786 27.9414 31.0074C28.1535 30.7908 28.5002 30.7908 28.7136 31.0074C28.9272 31.2253 28.9272 31.5756 28.7136 31.7922ZM17.5533 25.9722C17.5533 24.8434 18.4865 23.8969 19.5993 23.8969C20.7123 23.8969 21.6147 24.8434 21.6147 25.9722C21.6147 27.1009 20.7123 28.0159 19.5993 28.0159C18.4865 28.0159 17.5533 27.1009 17.5533 25.9722ZM38.625 23.7249C38.625 21.8722 37.1391 20.3649 35.3124 20.3649C34.47 20.3649 33.6759 20.6836 33.0675 21.2547C30.8811 19.8115 27.9531 18.8787 24.7108 18.751L26.4995 13.2146L31.197 14.3357C31.1985 15.8605 32.421 17.0994 33.9246 17.0994C35.428 17.0994 36.6521 15.8577 36.6521 14.3329C36.6521 12.8081 35.428 11.5664 33.9246 11.5664C32.7984 11.5664 31.8316 12.2602 31.4148 13.2496C30.4027 13.0078 26.7846 12.1431 25.7725 11.9013L23.5641 18.7396C20.199 18.8034 17.1496 19.7317 14.8813 21.2091C14.2802 20.6676 13.5022 20.3649 12.6861 20.3649C10.8609 20.3649 9.375 21.8722 9.375 23.7249C9.375 24.901 9.98047 25.9789 10.9486 26.5842C10.0668 31.8675 16.2049 36.4288 23.9387 36.4288C31.6401 36.4288 37.7577 31.908 36.9417 26.6512C37.9771 26.0625 38.625 24.9589 38.625 23.7249Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_917_405">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReddit;
